import React from "react";

/**
 * A component to display an "Abandoned" label for races or tracks
 * @param {Object} props Component props
 * @param {string} [props.className] Additional CSS classes
 * @param {string} [props.reason] Optional reason text for abandonment
 * @param {boolean} [props.showReason=false] Whether to show the reason in tooltip
 * @returns {JSX.Element} Abandoned label component
 */
const AbandonedLabel = ({
  className = "",
  reason = "",
  showReason = false,
}) => {
  return (
    <div
      className={`inline-flex items-center justify-center bg-red-600 text-white text-xs font-medium px-2 py-0.5 rounded-md ${className}`}
      title={showReason && reason ? reason : "Abandoned"}
    >
      Abandoned
    </div>
  );
};

export default AbandonedLabel;
